var env = window.env = window.env || {};
export var AuthorizationApiUri = env['authorizationApiUri'];
export var AuthorizationApiName = env['authorizationApiName'];
export var SingleTenantId = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';
//# sourceMappingURL=Constants.js.map